export default "__VITE_ASSET__6855eec3__"